import { useHistory } from 'react-router-dom';
import { Button } from '@givebutter/primitives/button';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getContactFormQueryParams } from 'assets/js/pages/contacts/contactFormParams';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const NewContactButton = ({ type = ContactType.Individual }: { type?: ContactType }) => {
    const history = useHistory();
    const { accountId } = useCurrentAccount();
    const resource = type === ContactType.Individual ? 'contacts' : 'companies';

    return (
        <Button
            variant="solid"
            onClick={() =>
                history.push({
                    pathname: `/accounts/${accountId}/${resource}/new`,
                    search: getContactFormQueryParams(
                        type === ContactType.Individual
                            ? { autoFocus: 'firstName' }
                            : {
                                  autoFocus: 'companyName',
                                  type: ContactType.Company,
                              },
                    ),
                })
            }
        >
            <FontAwesomeIcon icon={faPlus} />
            New Contact
        </Button>
    );
};

export { NewContactButton };
